import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { JopiThemeProvider } from '@quintoandar-tokko/jopijs';
import JOPI_UNIVEN_BRAND, { JOPI_BADGE_ON_BRAND_COLORS } from './brands/univen';

/**
 * Injects the jopi / styled-components theme for the app.
 *
 * Brand tokens for Univen live in this repo (private). jopi only ships Tokko
 * Broker and accepts a brand object at runtime.
 *
 * Both brands wire `buttons.onBrand` to `--color-brand-badges-background` so
 * Header/Sidebar can use badgeVariant={['badgeNormal', 'onBrand']}.
 *
 * syncDocumentTheme is false because SettingsReactLoader already sets
 * <html data-theme> from the URL / referrer (domain-based Univen detection).
 */
export default function AppThemeProvider({ children }) {
  const brandName = useSelector((state) => state.UserSlice.themeConfig.theme);

  const brand = useMemo(() => {
    if (brandName === 'univen') return JOPI_UNIVEN_BRAND;
    return { colors: JOPI_BADGE_ON_BRAND_COLORS };
  }, [brandName]);

  return (
    <JopiThemeProvider brand={brand} syncDocumentTheme={false}>
      {children}
    </JopiThemeProvider>
  );
}
